export default __webpack_public_path__ + "static/ICCAM_02-c4a378912df289a1ed21f9ebe7d0a5ee.webp";